import { useEffect, useState } from 'react';
import { FileModal } from '../../components/ComplianceModals';
import { useCompany } from '../../context/CompanyContext';
import api from '../../api';

function formatDate(dateStr) {
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

function ComplianceStatusTab() {
  const { selectedCompanyId } = useCompany();
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();

  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  const [modalItem, setModalItem] = useState(null);
  const [busyId, setBusyId] = useState(null);

  const load = () => {
    if (!selectedCompanyId) return;
    api
      .get(`/calendar/${selectedCompanyId}`, { params: { month, year } })
      .then((res) => {
        setItems(res.data.filter((it) => it.status !== 'filed'));
        setError(null);
      })
      .catch((err) => setError(err.message));
  };

  // month/year are derived from "today" and intentionally fixed for this tab's lifetime.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(load, [selectedCompanyId]);

  const openFileModal = (item) => {
    setModalItem(item);
  };

  const confirmFile = (payload) => {
    if (!modalItem) return undefined;
    setBusyId(modalItem.id);
    return api
      .post(`/compliance/${modalItem.id}/file`, payload)
      .then(() => {
        setModalItem(null);
        load();
      })
      .finally(() => setBusyId(null));
  };

  const markInProgress = (item) => {
    setBusyId(item.id);
    api
      .post(`/compliance/${item.id}/start`, {})
      .then(load)
      .finally(() => setBusyId(null));
  };

  return (
    <div className="dash-card">
      <h2 className="dash-card-title">Mark Compliance Status — {MONTH_NAMES[month - 1]} {year}</h2>
      <p className="dash-table-sub" style={{ marginBottom: 16 }}>
        Quickly update this month's pending filings without going to the Calendar screen.
      </p>

      {error && <p className="dash-error">{error}</p>}

      {items.length === 0 && <p className="dash-empty">Nothing pending for this month.</p>}

      {items.map((item) => (
        <div className="de-compliance-row" key={item.id}>
          <div className="de-compliance-left">
            <div className="form-name">
              {item.form_name}{' '}
              {item.status === 'overdue' && <span className="dash-pill dash-pill-red">Overdue</span>}
              {item.status === 'in_progress' && <span className="dash-pill dash-pill-inprogress">In Progress</span>}
              {item.status === 'pending' && <span className="dash-pill dash-pill-amber">Pending</span>}
            </div>
            <div className="due-date">Due {formatDate(item.due_date)} · {item.category}</div>
          </div>
          <div className="de-compliance-right">
            <button
              className="dash-btn cal-btn-grey"
              type="button"
              disabled={busyId === item.id || item.status === 'in_progress'}
              onClick={() => markInProgress(item)}
            >
              Mark In Progress
            </button>
            <button
              className="dash-btn dash-btn-orange"
              type="button"
              disabled={busyId === item.id}
              onClick={() => openFileModal(item)}
            >
              Mark Filed
            </button>
          </div>
        </div>
      ))}

      <FileModal
        item={modalItem}
        onClose={() => setModalItem(null)}
        onConfirm={confirmFile}
        busy={!!modalItem && busyId === modalItem.id}
      />
    </div>
  );
}

export default ComplianceStatusTab;
